// Set webpack public path
__webpack_public_path__ = document.querySelector('meta[name="base_assets"]').content;

import {HadronCollider} from "@webreact/webreactor";
import {components} from "./src";
import {defineTabs} from "@webreact/fissure-tabs";
defineTabs();


const componentRouter = new HadronCollider(components);

componentRouter.loadEvents();
